import { NgModule } from '@angular/core';

/**
 * This module is needed for when you want to integrate the workplace application
 * within MS Teams. It doesnt do anything really right now but is here for furture use.
 * */
@NgModule({
  declarations: [],
  imports: [],
  exports: []
})
export class MsTeamsModule {}
